export const GET_DELAYED_REQUEST = 'GET_DELAYED_REQUEST'
export const GET_DELAYED_SUCCESS = 'GET_DELAYED_SUCCESS'
export const GET_DELAYED_FAILURE = 'GET_DELAYED_FAILURE'